import { Box, Container } from "@mui/material";

const Section = (props: {
  children: React.ReactNode;
  backgroundColor?: any;
}): React.JSX.Element => (
  <Box
    data-testid="section-box"
    sx={{
      background: props.backgroundColor || "background.default",
      py: 4,
    }}
  >
    <Container maxWidth="xl" sx={{ py: 6 }}>
      {props.children}
    </Container>
  </Box>
);

export default Section;
